// BoardMenu.js
import React from "react";
import Header from "../components/Header";
import logo from "../assets/logo.webp";
import SectionButton from "../components/Buttons/SectionButton";

function BoardMenu() {
  return (
    <div>
      <Header />
      <div className="bg-[#f2f2f2] w-full h-max">
        <div className="flex items-center justify-center h-[93vh] bg-gray-100">
          <div className="bg-white rounded-lg shadow-lg p-8 md:w-[80%] max-md:w-[95%] border">
            <div className="flex flex-col items-center">
              <img src={logo} alt="Logo" className="mb-4 w-[125px] h-[73px]" />
              <h1 className="text-2xl text-[#1c2438] font-semibold mb-2 text-center">
                CHOIX DE LA SECTION
              </h1>
              <p className="text-[#FF8449] mb-4">Que souhaitez-vous faire ?</p>

              {/* Utilisation de grid pour afficher 2 cartes par ligne */}
              <div className="grid grid-cols-1 gap-4">
                <SectionButton
                  title={"Souscrire"}
                  content={
                    "Assistez votre client à souscrire à un contrat d'assurance frontière"
                  }
                  linkText={"Accéder"}
                  linkUrl={"/souscrire"}
                />
                {/* <SectionButton
                  title={"Renouveler une assurance"}
                  content={
                    "Assistez votre client à renouveler un contrat d'assurance frontière"
                  }
                  linkText={"Accéder"}
                  linkUrl={"/login"}
                /> */}
                {/* <SectionButton
                  title={"Support"}
                  content={"Faites appel à l'équipe de support"}
                  linkText={"Accéder"}
                  linkUrl={"/login"}
                />
                <SectionButton
                  title={"Contactez-nous"}
                  content={"Prenez contact avec nos équipes"}
                  linkText={"Accéder"}
                  linkUrl={"https://www.digis-assur.net"}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BoardMenu;
